<template>
	<div class="cents">
		<van-nav-bar :title='$t("xgryzl")' left-arrow safe-area-inset-top style="background-color: #1ABC9C;"
			@click-left="goto" />
		<div class="box">
			
			<!-- 用户姓名 -->
			<div class="nameBox">
				<div class="name">{{$t('yhxm')}}</div>
				<input type="text" class="nameInput" v-model="nameVal" />
			</div>
			<!-- 性别 -->
			<div class="nameBox">
				<div class="name">{{$t('xb')}}</div>
				<input type="text" readonly='read' class="nameInput" style="margin-left: 62px;"
					v-model="ganderVal" @click="handleGender" />
				<div class="ganderList" v-if="ganderState">
					<div class="ganderItem" @click="chooseGender('男')">{{$t('nbool')}}</div>
					<div class="ganderItem" style="border-bottom: none;" @click="chooseGender('女')">{{$t('ngril')}}</div>
				</div>
			</div>
			<!-- 手机号码 -->
			<div class="nameBox">
				<div class="name">{{$t('sjhm')}}</div>
				<input type="text" class="nameInput" v-model="mobileVal" />
			</div>
			<!-- 证件号码 -->
			<div class="nameBox">
				<div class="name">{{$t('zjhm')}}</div>
				<input type="text" class="nameInput" v-model="numberVal" />
			</div>
			<!-- 工号输入 -->
			<div class="nameBox">
				<div class="name">{{$t('gh')}}</div>
				<input type="text" class="nameInput" v-model="jobNumberVal"
					style="margin-left: 58px;" />
			</div>
			<!-- 卡号输入 -->
			<div class="nameBox">
				<div class="name">{{$t('kh')}}</div>
				<input type="text" class="nameInput" v-model="cardVal" style="margin-left: 58px;" />
			</div>
			<!-- 开门密码 -->
			<div class="nameBox">
				<div class="name">{{$t('kmmm')}}</div>
				<input type="text" class="nameInput" v-model="passwordVal" />
			</div>
			<!-- 部门选择 -->
			<div class="nameBox">
				<div class="name">{{$t('bmxz')}}</div>
				<input type="text" class="nameInput" readonly='read' @click="chooseDept"
					v-model="deptName" />
				<van-popup v-model="show" position="bottom" :style="{ height: '50%' }">
					<div style="padding:10px 10px">
						<tree :setting="setting" :nodes="treeDatas" @onClick="onClick" @onCheck="onCheck" />
					</div>
				</van-popup>
			</div>
			<!-- 有效开始时间 -->
			<div class="nameBox">
				<div class="name">{{$t('yxkssj')}}</div>
				<!-- <input type="text" class="nameInput" style="width: 177px;" placeholder="格式:2022-1-1"
					v-model="starTime" /> -->
				<el-date-picker v-model="starTime" type="date" @change="starTimeChange">
				</el-date-picker>
			</div>
			<!-- 有效结束时间 -->
			<div class="nameBox">
				<div class="name">{{$t('yxjssj')}}</div>
				<!-- <input type="text" class="nameInput" style="width: 177px;" placeholder="格式:2022-1-1"
					v-model="endTime" /> -->
				<el-date-picker v-model="endTime" type="date" @change="endTimeChange">
				</el-date-picker>
			</div>
			<!-- 设置头像 -->
			<div class="setImg">
				<div class="setImgTxt">{{$t('sztx')}}</div>
				<div class="setImgContent fileinput-buttom">
					<img :src="img" class="image" />
					<!-- <img src="../../assets/images/devicebg.png"  class="image" v-else/> -->
					<h5-cropper :option="option" @getbase64Data="getbase64Data" @getblobData="getblobData"
						@getFile="getFile" @canceltailor="canceltailor"></h5-cropper>
				</div>
			</div>

			<div class="line"></div>
			<!-- 确认按钮 -->
			<div class="btn" @click="handleBtn">
				{{$t('bc')}}
			</div>
		</div>
	</div>
</template>

<script>
	import tree from "vue-giant-tree";
	import {
		Toast
	} from 'vant';
	import methodlist from "@/utils/methods";
	import jq from 'jquery'
	import H5Cropper from 'vue-cropper-h5'
	var Base64 = require("js-base64").Base64;
	export default {
		data() {
			return {
				UserInfo: JSON.parse(window.localStorage.getItem("getTokendata")), // 本地缓存 获取用户数据
				User: JSON.parse(window.localStorage.getItem("user")), // 本地缓存 获取用户数据
				img: require('@/assets/images/selectfile.png'),
				personInfo: {}, // 人员信息
				nameVal: '', // 姓名
				ganderVal: '', // 性别
				mobileVal: '', // 手机号码
				numberVal: '', // 证件号码
				jobNumberVal: '', // 工号
				deptName: '', // 部门名
				deptId: '', // 部门id
				cardVal: '', // 卡号
				passwordVal: '', // 开门密码
				starTime: '', // 开始时间
				endTime: '', // 结束时间
				option: {
					outputType: "jpeg",
					fixedBox: false
				},
				faceimg: {
					up_img_name_src: "",
					up_img_name_dst: "",
					person_id: "",
					up_img_flag: 0,
				},
				headers: null,
				ganderState:false, // 性别选择框状态
				show: false, // 选择部门 状态
				setting: { // tree 配置
					check: {
						enable: true //树是否带复选框或者单选框
					},
					data: {
						simpleData: {
							enable: true, //是否使用简单数据模式
							pIdKey: "pid" //父级id
						}
					},
					view: {
						showIcon: false,
						addHoverDom: this.addHoverDom,
						removeHoverDom: this.removeHoverDom,
					}
				},
				treeDatas: [], //tree数据
			}
		},
		components: {
			tree,
			H5Cropper
		},
		beforeMount() {
			this.getDemp()
			this.getPersonInfo()
		},
		methods: {
			// 更改接口
			
			personAdd(){
				let data = {
					method:'co.person.edit',
					name:this.nameVal,
					id:this.$route.query.id,
					gender:this.ganderVal=='男'||this.ganderVal=='male'?0:1,
					origin:this.personInfo.origin,
					birthplace:this.personInfo.birthplace,
					type:this.personInfo.type,
					card_no:this.cardVal,
					remark:this.personInfo.remark,
					mobile:this.mobileVal,
					credential_type:this.personInfo.credential_type,
					credential:this.numberVal,
					birthday:this.personInfo.birthday,
					nation:this.personInfo.nation,
					door_password:this.passwordVal,
					dept_id:this.deptId,
					start_time:this.starTime/1000,
					end_time:this.endTime/1000,
					is_update_door_password:1,
					is_update_face:1,
					is_update_card_no:1,
					is_update_key_time:1,
					is_update_name:1,
					number:this.jobNumberVal
				}
				this.$https(data).then(res=>{
					if(res.data.code==0){
						Toast.success($t('xgcg'));
						let dataInfo = {
							method: 'co.wx.face.update',
							signature:'',
							user_id:this.$route.query.id,
							pic_url:this.faceimg.up_img_name_src
						}
						this.$serve(dataInfo).then(res1=>{
							console.log(res1)
							console.log('上传图片接口成功');
						})
					}else if(res.data.code==-3){
						Toast.fail($t('rybcz'))
					}else if(res.data.code==-14){
						Toast.fail($t('khbcz'))
					}else{
						Toast.fail($t('sbcwm')+'：'+res.data.code)
					}
				})
			},
			// 点击保存 调用添加接口
			handleBtn() {
				if (this.nameVal == '') {
					Toast.fail($t('qsryhm'))
				}  else if (this.jobNumberVal == '') {
					Toast.fail($t('qsrgh'))
				} else if (this.deptName == '') {
					Toast.fail($t('qxzbm'))
				}  else {
					this.personAdd()
				}
			},
			// 性别选择后 赋值
			chooseGender(text) {
				this.ganderVal = text;
				if(text=='男'){
					this.ganderVal = this.$t('nbool');
				}else{
					this.ganderVal = this.$t('ngril');
				}
				this.ganderState = false
				console.log(this.ganderVal)
			},
			// 选择部门
			onCheck: function(evt, treeId, treeNode) {
				console.log(`3`, treeNode.id)
				this.deptName = treeNode.name
				this.deptId = treeNode.id
			},
			// 点击部门框
			onClick(evt, treeId, ) {
				console.log(`1`, evt)
				console.log(`2`, treeId)
			},
			// 获取部门列表
			getDemp() {
				let data = {
					method: 'co.wx.dept.list',
					user_id: this.UserInfo.user_id,
					agent_id: this.UserInfo.agent_id
				}
				this.$serve(data).then(res => {
					this.treeDatas[0] = this.getFirstObj(res.data.data)
				})
			},
			// 对象 变数组
			getFirstObj(obj) {
				for (var key in obj) {
					return obj[key];
				}
			},
			// 修改时间
			// 开始
			starTimeChange(e){
				console.log(e.getTime()/1000);
				console.log(this.starTime)
				this.starTime = e.getTime()
				console.log(this.starTime)
			},
			// 结束
			endTimeChange(e){
				console.log(e.getTime()/1000);
				this.endTime = e.getTime()
			},
			// 部门选择
			chooseDept() {
				this.show = true
			},
			// 点击性别 选择框 控制性别选择下拉框 状态
			handleGender() {
				this.ganderState = !this.ganderState
			},
			//  裁剪后base64返回
			getbase64Data(data) {
				this.img = data;
				console.log(`0`, data)
			},
			getblobData(data) {
				console.log(`1`, data)
			},
			getFile(data) {
				let filex = data
				var reader = new FileReader();
				let _this = this;
				reader.readAsDataURL(filex);
				reader.onload = function(e) {
					let es = e.target.result;
					let mqttInfo =
						_this.UserInfo.mqtt_serial + ":" + _this.UserInfo.mqtt_password;
					let curTimestamp = new Date().getTime();
					_this.faceimg.up_img_name_src = methodlist.type_face + curTimestamp + ".jpeg";
			
					let up_url_Path = methodlist.upload_img_base + _this.faceimg.up_img_name_src;
			
					_this.action = up_url_Path;
					var data = "temporary=true&imgBase64=" + es.substring("data:image/jpeg;base64,".length);
					_this.headers = {
						Authorization: "Basic " + Base64.encode(mqttInfo),
						"Content-MD5": _this.$md5(data),
						"Content-Type": "application/x-www-form-urlencoded",
					};
					jq.ajax({
						headers: {
							Authorization: "Basic " + Base64.encode(mqttInfo),
							"Content-MD5": _this.$md5(data),
						},
						url: "https://web.fondcard.net/open/store/api.php?" + _this.faceimg.up_img_name_src,
						type: "POST",
						contentType: "application/x-www-form-urlencoded",
						data: data,
						success: function(res) {
							Toast.success($t('scgg'));
							_this.img = methodlist.resident_pic_base + res;
							
						},
						error: function(res) {
							console.log(res)
							Toast.fail($t('scsb'));
						},
					});
				}
			
			},
			// 获取人员信息
			getPersonInfo() {
				let data = {
					method: 'co.person.get',
					id: this.$route.query.id,
				}
				this.$https(data).then(res => {
					console.log(res)
					if (res.data.code == 0) {
						this.personInfo = res.data.data;
						this.nameVal = res.data.data.name;
						this.ganderVal = res.data.data.gender ? this.$t('ngril') : this.$t('nbool');
						this.mobileVal = res.data.data.mobile;
						this.numberVal = res.data.data.credential;
						this.jobNumberVal = res.data.data.number;
						this.deptId = res.data.data.dept_id;
						this.cardVal = res.data.data.card_no;
						this.passwordVal = res.data.data.door_password;
						if(res.data.data.start_time!=0){
							this.starTime = this.getTime(res.data.data.start_time);
						}
						if(res.data.data.end_time!=0){
							this.endTime = this.getTime(res.data.data.end_time);
						}
						// this.endTime = this.getTime(res.data.data.end_time);
						this.foundDept(this.treeDatas,res.data.data.dept_id);
						this.img  = res.data.data.face_url
						if(res.data.data.face_url!=''){
							this.img = methodlist.resident_pic_base+res.data.data.face_url
						}
					} else {
						this.$message.info($t('ryxxhqsb'))
					}
				})
			},
			// 时间转换 毫秒变日期
			getTime(time) {
				let starYear = new Date(time * 1000).getFullYear();
				let starMonth = new Date(time * 1000).getMonth() + 1;
				let starDay = new Date(time * 1000).getDate();
				let starTimes = starYear+'-'+starMonth+'-'+starDay;
				return starTimes
			},
			// 部门id对应名字
			foundDept(list,dept_id){
				console.log(list,dept_id)
			  list.forEach(item=>{
			    if(item.id == dept_id){
			      this.deptName = item.name
			    }else{
			      if(item.children){
			        this.foundDept(item.children,dept_id)
			      }
			    }
			  })
			 },
			// 返回上一页
			goto() {
				this.$router.go(-1)
			},
			canceltailor(data) {
				console.log(`3`, data)
			},
		}
	}
</script>

<style scoped>
	.box {
		padding: 0 15px;
	}

	.setImg {
		display: flex;
		justify-content: space-between;
		border-top: 1px solid #ccc;
		padding: 10px 15px;
	}

	.setImgTxt {
		margin: auto 0;
		color: #555;
	}

	.fileinput-buttom {
		position: relative;
		display: inline-block;
		overflow: hidden;
	}

	.fileinput-buttom input {
		position: absolute;
		left: 0;
		top: 0;
		opacity: 0;
	}

	.upbtn {
		position: absolute;
		left: 0;
		top: 12px;
	}

	.image {
		width: 50px;
		height: 50px;
		border-radius: 50%;
	}

	.nameBox {
		display: flex;
		padding-left: 15px;
		margin: 10px 0 20px;
		position: relative;
		height: 36px;
	}

	.ganderList {
		position: absolute;
		top: 35px;
		right: 24px;
		z-index: 999;
		width: 210px;
		background-color: #ccc;
		border-radius: 0 0 10px 10px;
	}

	.ganderItem {
		padding: 5px;
		text-align: left;
		padding-left: 20px;
		border-bottom: 1px solid #000;
	}

	.name {
		color: #555;
		margin: auto 0;
	}

	.nameInput {
		border: 1px solid #555;
		padding: 5px 10px;
		border-radius: 5px;
		width: 210px;
		margin-left: 30px;
	}

	.line {
		height: 1px;
		background-color: #ccc;
		margin: 0 0 25px;
	}

	.btn {
		background-color: #1ABC9C;
		color: #fff;
		width: 75px;
		text-align: center;
		height: 30px;
		line-height: 30px;
		font-size: 13px;
		border-radius: 5px;
		margin: 0 auto;
	}

	.cents>>>.van-nav-bar__title {
		color: #fff;
	}

	.cents>>>.van-nav-bar .van-icon {
		color: #fff;
	}
</style>
